import React from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Import React Router components
import NavBar from './layout/NavBar';
import Home from './layout/Header';
import ScrollToTop from "./pages/ScrollToTop";
import './App.css';
import AboutUs from "./pages/AboutUs";
import Footer from "./layout/Footer";
import ContactUs from "./pages/ContactUs";
import OverView from "./pages/OverView";
import SupportPage from "./pages/Support";
import OurServices from "./pages/OurServices";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from "./pages/TermsAndConditions";
import Careers from "./pages/Careers";

// Define theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#003457',
    },
    tertiary: {
      main: '#05aff2',
    },
  },
  typography: {
    fontFamily: 'Verdana,serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/expertize" element={<OverView />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsAndConditions />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
